import React from "react";
import Header from "../../components/Header/Header";
import NavBar from "../../components/NavBar/NavBar";
import Slider from "../../components/slider/slider";
import BookNow from "../../components/BookNow/BookNow";
import "./Home.css";
import prescription from "../../assets/desktop-rx.webp";
import consultant from "../../assets/consultation2.webp";
import homeService from "../../assets/homeservice2.webp";
import homeTest from "../../assets/home-labtest.webp";

import productsData from "./product.json";

import ProductCarousel from "../../components/ProductCarousel/ProductCarousel";
import Partners from "../../components/Partners/Partners";

import herbalProduct from "./herbal.json";
import Footer from "../../components/Footer/Footer";

const bookNowData = [
  {
    backgroundColor: "#FFEAD4",
    heading: "Have a prescription?",
    paragraph: "Upload prescription and  we will create your order!",
    buttonText: "Order Now",
    imageAlt: prescription,
    backgroundButtonColor: "#F29D43",
    link: "/AsaanOrder",
  },
  {
    backgroundColor: "#def0ef",
    heading: "Doctor Consultant",
    paragraph: "speak to specialists book your appointment",
    buttonText: "Book Now",
    imageAlt: consultant,
    backgroundButtonColor: "#32AA9E",
    link: "/Consultant",
  },
  {
    backgroundColor: "#f2f2f0",
    heading: "Home Services",
    paragraph: "At home services you can call we will come",
    buttonText: "Book Now",
    imageAlt: homeService,
    backgroundButtonColor: "#2a579b",
    link: "/HomeService",
  },
  {
    backgroundColor: "#f7dedb",
    heading: "Lab test & checkups",
    paragraph: "Lab at home free on call available",
    buttonText: "Book Now",
    imageAlt: homeTest,
    backgroundButtonColor: "#2a579b",
    link: "/LabTest",
  },
];

function Home() {
  return (
    <div>
      <Header />
      <NavBar />
      <Slider />
      <div className="home-container">
        <div className="Home">
          {bookNowData.map((bookData, index) => (
            <BookNow key={index} {...bookData} />
          ))}
        </div>
      </div>
      <ProductCarousel title="Popular Products" productsData={productsData} />
      {/* <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "5%",
          marginRight: "5%",
        }}
      >
        <img
          src={leftArrow}
          alt=""
          // onClick={handlePreviousBrand}
          style={{ cursor: "pointer", height: "20px" }}
        />
        <img
          src={rightArrow}
          alt=""
          style={{ cursor: "pointer", height: "20px", marginLeft: "2%" }}
        // onClick={handleNextBrand}
        />
      </div>
      <div style={{ display: "flex", gap: "1.5%", marginTop: "-2%" }}>
        <div className="TopBrand">
          <h2>Top Brands</h2>
        </div>
        {brandsData.map((brand, index) => (
          <Brands image={brand.image} name={brand.name} />
        ))}
      </div> */}

      {/* <div style={{ marginTop: '6%' }}>
        <ProductCarousel title="Daily Well-being" productsData={dailyProduct} />
      </div> */}

      <div style={{ marginTop: "6%" }}>
        <ProductCarousel
          title="Homeopathic & Herbal Products"
          productsData={herbalProduct}
        />
      </div>
      <div style={{ marginTop: "6%", marginBottom: "6%" }}>
        <ProductCarousel
          title="Medical Equipments"
          productsData={herbalProduct}
        />
      </div>

      <Partners />
      <Footer />
    </div>
  );
}

export default Home;
